import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Injects JSON-LD structured data (Article, WebPage, BreadcrumbList, etc.).
 * Pass a single object or @graph array.
 */
export default function JsonLd({ schema }) {
  if (!schema) return null;
  const payload = Array.isArray(schema['@graph']) ? schema : schema;
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(payload)}</script>
    </Helmet>
  );
}
